import request from '@/utils/request'

// 分页查询轮播图列表
export function getBannerPage(data) {
    return request({
        url: '/admin/banner/page',
        method: 'post',
        data: data
    })
}

// 获取轮播图详情
export function getBannerDetail(id) {
    return request({
        url: '/admin/banner/detail?id=' + id,
        method: 'get'
    })
}

// 新增轮播图
export function insertBanner(data) {
    return request({
        url: '/admin/banner/insert',
        method: 'post',
        data: data
    })
}

// 修改轮播图
export function updateBanner(data) {
    return request({
        url: '/admin/banner/update',
        method: 'post',
        data: data
    })
}

// 删除轮播图
export function deleteBanner(id) {
    return request({
        url: '/admin/banner/delete?id=' + id,
        method: 'get'
    })
}

// 获取所有启用的轮播图列表
export function listEnabledBanners() {
    return request({
        url: '/admin/banner/listEnabled',
        method: 'get'
    })
}
